<template>
  <page-view class="tms-shell-bill tms-style">
    <div slot="pageRight">
      <div class="bill-search">
        <p class="title">账单查询</p>
        <div class="flex">
          <el-form
            style="flex: 1"
            ref="searchForm"
            :model="searchForm"
            label-width="100px"
          >
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="账单号">
                  <el-input
                    size="small"
                    v-model="searchForm.InvoiceNo"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="订单号">
                  <el-input
                    size="small"
                    v-model="searchForm.CustomerOrderNo"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="账单区间">
                  <el-date-picker
                    v-model="billDate"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="16">
              <el-col :span="8">
                <el-form-item label="支付状态">
                  <el-select
                    style="width:100%"
                    size="small"
                    :popper-append-to-body="false"
                    v-model="searchForm.payStatus"
                    placeholder="请输入"
                  >
                    <el-option :value="0" label="未支付">未支付</el-option>
                    <el-option :value="2" label="已支付">已支付</el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
          <div style="margin-top: 10px">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="goSearch"
              :loading="fullscreenLoading"
            >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-refresh-right"
              @click="reset"
              :loading="fullscreenLoading"
            >重置</el-button
            >
          </div>
        </div>
      </div>
      <div
        class="bill-list"
        v-loading="fullscreenLoading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(196,196,204, 0.8)">
        <p class="title">明细查看</p>
        <Collapse v-if="listData && listData.length" :accordion="true">
          <Panel
            v-for="item in listData"
            :key="item.InvoiceNo"
            class="list-item"
            :name="item.InvoiceNo"
          >
            <div slot="header">
              <img class="header_icon" src="@/assets/tms/bill_item_icon.png" />
              <div class="order-no">账单号：{{ item.InvoiceNo }}</div>
              <div class="order-head-infomation">
                <Description
                  style="width: 25%"
                  label="金额"
                  :content="item.Amount"
                />
                <Description
                  style="width: 25%"
                  label="未税金额"
                  :content="item.NotRateAmount"
                />
                <Description style="width: 25%" label="税额" :content="item.RateAmount" />
                <Description style="width: 25%" label="税率" :content="item.TaxRate" />
                <Description style="width: 25%" label="币种" :content="item.CurrType" />
                <Description
                  style="width: 25%"
                  label="账单日期"
                  :content="item.InvoiceDate"
                />
                <Description style="width: 25%" label="是否开票" :content="item.BTaxInvoice" />
                <Description
                  style="width: 25%"
                  label="发票日期"
                  :content="item.TaxInvoiceDate"
                />
                <Description
                  style="width: 25%"
                  label="发票号"
                  :content="item.TaxInvoiceNo"
                />
                <Description
                  style="width: 25%"
                  label="支付日期"
                  :content="item.PaymentDate"
                />
                <Description
                  style="width: 25%"
                  label="支付状态"
                  :content="item.PaymentStatus"
                />
              </div>
            </div>
            <template slot="content">
              <div class="detail-info">
                <el-table
                  :data="item.OrderData"
                  :row-class-name="tableRowClassName"
                  style="width: 100%">
                  <el-table-column
                    prop="CustomerOrderNo"
                    label="订单号"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="JobMonth"
                    label="费用月度"
                    width="180">
                  </el-table-column>
                  <el-table-column
                    prop="ChargeName"
                    label="费用名称">
                  </el-table-column>
                  <el-table-column
                    prop="CurrType"
                    label="币种">
                  </el-table-column>
                  <el-table-column
                    prop="NotRateAmount"
                    label="未税金额">
                  </el-table-column>
                  <el-table-column
                    prop="RateAmount"
                    label="税额">
                  </el-table-column>
                  <el-table-column
                    prop="TaxRate"
                    label="税率">
                  </el-table-column>
                  <el-table-column
                    prop="Amount"
                    label="金额">
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </Panel>
        </Collapse>
        <div v-else style="text-align:center;padding:20px">暂无数据</div>
        <el-pagination
          v-show="listData && listData.length"
          background
          style="text-align:right"
          :page-size="pageInfo.PageSize"
          :page-sizes="[5, 10, 20, 50,100]"
          layout="prev,sizes, pager, next"
          @current-change="currentChange"
          @size-change="handleSizeChange"
          :total="pageInfo.Total">
        </el-pagination>
      </div>
      <div class="total-info">
        <div class="total-info-label">合计账单数量</div>
        <div class="total-info-value">{{ pageInfo.Total }}</div>
        <div class="separator"></div>
        <div class="total-info-label">未税总金额</div>
        <div class="total-info-value">{{ totalCalculationNotRateAmount }}</div>
        <div class="separator"></div>
        <div class="total-info-label">税总额</div>
        <div class="total-info-value">{{ totalCalculationRateAmount }}</div>
        <div class="separator"></div>
        <div class="total-info-label">总金额</div>
        <div class="total-info-value">{{ totalCalculationAmount }}</div>
      </div>
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components'
import { Collapse, Panel } from '@/components/OrderCollapse'
import Description from '@/components/Description'
import { getinvoicelist } from '@/api/tms'
import moment from 'moment'
export default {
  components: {
    PageView,
    Collapse,
    Panel,
    Description
  },
  data() {
    return {
      moment,
      searchForm: {},
      pageInfo: {
        PageIndex: 1,
        PageSize: 5,
        Total: 0
      },
      billDate: [],
      listData: [],
      totalCalculationNotRateAmount: 0,
      totalCalculationRateAmount: 0,
      totalCalculationAmount: 0,
      fullscreenLoading: false
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      const params = {
        ...this.searchForm,
        InvoiceDateStart: this.billDate[0] || '',
        InvoiceDateEnd: this.billDate[0] || '',
        PageIndex: this.pageInfo.PageIndex,
        PageSize: this.pageInfo.PageSize
      }
      this.listData = []
      this.fullscreenLoading = true
      getinvoicelist(params).then(res => {
        this.fullscreenLoading = false
        if (!res.Data) return
        this.listData = res.Data.Data || []
        this.pageInfo.Total = res.Data.Total
        this.totalCalculationNotRateAmount = res.Data.TotalCalculationNotRateAmount || 0
        this.totalCalculationRateAmount = res.Data.TotalCalculationRateAmount || 0
        this.totalCalculationAmount = res.Data.TotalCalculationAmount || 0
        if (this.pageInfo.PageIndex > 1 && !res.Data.Data.length) {
          this.goSearch()
        }
      }).catch(() => {
        this.fullscreenLoading = false
      })
    },
    goSearch() {
      this.pageInfo = {
        PageIndex: 1,
        PageSize: 5,
        Total: 0
      }
      this.getData()
    },
    reset() {
      this.searchForm = {}
      this.billDate = []
      this.goSearch()
    },
    currentChange(value) {
      this.pageInfo.PageIndex = value
      this.getData()
    },
    handleSizeChange(val) {
      this.pageInfo.PageSize = val
      this.goSearch()
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
        return 'warning-row'
      } else if (rowIndex % 2 === 1) {
        return 'success-row'
      }
      return ''
    }
  }
}
</script>
<style lang="less">
.tms-shell-bill {
  padding: 10px;
  background: #f0f6fb;
  position: relative;
  padding-bottom: 50px;
  .plr25 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .ptb25 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .bill-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .bill-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    min-height:60vh;
    .list-item {
      margin-bottom: 8px;
    }
  }
  .header_icon {
    width: 34px;
    height: 34px;
    display: inline-block;
  }
  .order-no {
    font-size: 16px;
    font-weight: 400;
    color: #111827;
    margin-left: 18px;
    display: inline-block;
  }
  .order-head-infomation {
    padding-left: 52px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 16px 0;
  }
  .detail-info {
    .warning-row {
      background: #FFFFFF;
    }
    .success-row {
      background: #F2FBFF;
    }
  }
  .total-info {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f0fcff;
    height: 40px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right:20px;
    .total-info-label {
      font-size: 12px;
      font-weight: 400;
      color: #9ca3af;
      line-height: 17px;
    }
    .total-info-value {
      font-size: 14px;
      font-weight: 500;
      color: #59b9d3;
      line-height: 20px;
      margin-left: 10px;
    }
    .separator {
      margin:0 7px;
      padding:10px 0;
      width:1px;
      border-left: 0.5px solid #E9ECF2;
    }
  }
}
</style>
